import React, { useEffect, useState } from 'react'
import { createProject, listProjects, updateProject } from '../../Accounts/API'
import Modal from '../Modal'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { setDialog as setDialogConnect } from '../../../actions/navigation'
import { removeExtraneousState } from '../../../actions/savedState'
import Checkbox from '../../Checkbox'

const ProjectSave = ({ state, setDialog }) => {
    const [projects, setProjects] = useState([])
    const [saveType, setSaveType] = useState('new')
    const [selectedProject, setSelectedProject] = useState('') // uuid
    const [name, setName] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(false)

    useEffect(() => {
        const getList = async () => {
            setIsLoading(true)
            const projectArray = await listProjects()
            setProjects(projectArray)
            setIsLoading(false)
        }

        getList()
    }, [])

    const onSelectSaveType = ({ target: { value } }) => {
        setSaveType(value)

        if (value === 'new') {
            setSelectedProject(null)
            setName('')
        }

        if (value === 'existing') {
            const { name: projectName, uuid } = projects[0]

            setSelectedProject(uuid)
            setName(projectName)
        }
    }

    const onSelectProject = e => {
        const uuid = e.target.value
        const project = projects.find(p => p.uuid === uuid)

        setSelectedProject(uuid)
        setName(project.name)
    }

    const onSubmit = async () => {
        setIsLoading(true)
        const winnowedState = removeExtraneousState(state)

        try {
            if (saveType === 'new') {
                await createProject({ name, state: winnowedState })
            }
            if (saveType === 'existing') {
                await updateProject(selectedProject, { name, state: winnowedState })
            }
        } catch (e) {
            setError(true)
            return
        } finally {
            setIsLoading(false)
        }

        setSuccess(true)
    }

    const CloseButton = () => (
        <div className="top-margin-8">
            <button type="button" className="button is-neutral" onClick={() => setDialog('')}>
                Close
            </button>
        </div>
    )

    const submitted = success || error

    return (
        <Modal>
            <div className="project-save is-static-size-4">
                <header>
                    <h2 className="title">Save Project</h2>
                </header>
                <div className={`submit-message ${submitted ? '' : 'hide'}`}>
                    <p>
                        {success
                            ? 'Project saved successfully.'
                            : 'There was a problem saving your project. Please try again later.'}
                    </p>
                    <CloseButton />
                </div>
                <div className={`form ${submitted ? 'hide' : ''}`}>
                    <label className="label" htmlFor="select-save-type">
                        <strong>Save as</strong>
                    </label>
                    <select
                        id="select-save-type"
                        className="select"
                        value={saveType}
                        onChange={onSelectSaveType}
                        disabled={isLoading}
                    >
                        <option value="new">New Project</option>
                        <option value="existing" disabled={!projects.length}>
                            Existing Project
                        </option>
                    </select>
                    {saveType === 'existing' && (
                        <div className="top-margin-8">
                            <label className="label" htmlFor="select-project">
                                <strong>Select Project</strong>
                            </label>
                            <select
                                id="select-project"
                                value={selectedProject}
                                className="select"
                                onChange={onSelectProject}
                                disabled={isLoading}
                            >
                                {projects.map(project => (
                                    <option key={project.uuid} value={project.uuid}>
                                        {project.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                    <div className="top-margin-8">
                        <label className="label" htmlFor="name">
                            <strong>Name</strong>
                        </label>
                        <input
                            id="name"
                            className="input"
                            type="text"
                            onChange={e => setName(e.target.value)}
                            value={name}
                            disabled={isLoading}
                        />
                    </div>
                    <div className="top-margin-8">
                        <button
                            type="button"
                            className="button is-primary"
                            onClick={onSubmit}
                            disabled={!name || isLoading}
                        >
                            {saveType === 'new' ? 'Submit' : 'Update'}
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

ProjectSave.propTypes = {
    // redux state
    state: PropTypes.shape({}).isRequired,
    // redux actions
    setDialog: PropTypes.func.isRequired
}

const mapStateToProps = state => ({ state })

export default connect(mapStateToProps, dispatch => ({
    setDialog: modalName => dispatch(setDialogConnect(modalName))
}))(ProjectSave)
